import { Col, Container, Row } from "react-bootstrap";
import BuildingAmenityForm from "../../../Components/Forms/BuildingAmenityForm/BuildingAmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewBuildingAmenityMutation } from "../../../services/bClientApi";
import useBuildingSelectValues from "../../../Hooks/UseBuildings/useBuildingSelectValuesHook";
import useAmenitySelectValues from "../../../Hooks/UseAmenities/useAmenitySelectValuesHook";

export default function AddBuildingAmenityPage() {

    const [
        addNewBuildingAmenity,
        {
            isLoading,
            error
        }
    ] = useAddNewBuildingAmenityMutation()

    const buildingOptions = useBuildingSelectValues()
    const amenityOptions = useAmenitySelectValues()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const newBuildingAmenity = await addNewBuildingAmenity(values).unwrap()
        if (newBuildingAmenity._id) {
            dispatch(navigateTo(`/building-amenity/${newBuildingAmenity._id}`))
        }
        return newBuildingAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Add Building Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <BuildingAmenityForm
                        initialValues={{
                            buildingId: '',
                            amenityId: '',
                            overrides: {},
                        }}
                        disabled={isLoading}
                        onSubmit={handleSubmit}
                        buildingOptions={buildingOptions}
                        amenityOptions={amenityOptions}
                    />

                </Col>
            </Row>
        </Container>
    )
}
